// سازنده‌ی سادهِ فایلِ MP4 (یک ترکِ ویدیو، فریم‌ریتِ ثابت) برای فریم‌هایی که WebCodecs (VideoEncoder) فشرده کرده.
// فهرستِ فیلم (moov) اولِ فایل است (faststart) تا پخش قبل از کامل دانلود شدن شروع شود.
// codec: 'avc' (H.264، description = AVCDecoderConfigurationRecord که خودِ encoder می‌دهد) یا 'vp9'.
// samples: [{ data: Uint8Array, key: boolean }] به ترتیبِ پخش (بدونِ B-frame)

const enc = new TextEncoder();
const u8 = (...a) => new Uint8Array(a);
const u16 = (n) => u8((n >>> 8) & 255, n & 255);
const u32 = (n) => u8((n >>> 24) & 255, (n >>> 16) & 255, (n >>> 8) & 255, n & 255);
const str = (s) => enc.encode(s);

function cat(parts) {
  const len = parts.reduce((a, p) => a + p.length, 0);
  const out = new Uint8Array(len);
  let o = 0;
  parts.forEach((p) => {
    out.set(p, o);
    o += p.length;
  });
  return out;
}
const box = (type, ...parts) => {
  const body = cat(parts);
  return cat([u32(body.length + 8), str(type), body]);
};
const fullBox = (type, version, flags, ...parts) => box(type, u8(version, (flags >>> 16) & 255, (flags >>> 8) & 255, flags & 255), ...parts);
const zeros = (n) => new Uint8Array(n);
const MATRIX = cat([u32(0x00010000), u32(0), u32(0), u32(0), u32(0x00010000), u32(0), u32(0), u32(0), u32(0x40000000)]);

function sampleEntry({ codec, width, height, description, vp9 }) {
  const common = cat([
    zeros(6),
    u16(1), // data_reference_index
    zeros(16),
    u16(width),
    u16(height),
    u32(0x00480000),
    u32(0x00480000),
    u32(0),
    u16(1), // frame_count
    zeros(32), // compressorname
    u16(0x18),
    u16(0xffff),
  ]);
  if (codec === 'avc') return box('avc1', common, box('avcC', new Uint8Array(description)));
  const v = vp9 || {};
  const vpcC = fullBox(
    'vpcC',
    1,
    0,
    u8(v.profile || 0, v.level || 31, ((v.bitDepth || 8) << 4) | (1 << 1) | 0, 1, 1, 1),
    u16(0)
  );
  return box('vp09', common, vpcC);
}

// fps: فریم بر ثانیه؛ خروجی Blob (video/mp4)
export function muxMp4({ codec, width, height, fps, description, vp9, samples }) {
  const timescale = fps * 1000;
  const delta = 1000;
  const n = samples.length;
  const durTs = n * delta;
  const durMs = Math.round((n * 1000) / fps);
  const keys = [];
  samples.forEach((s, i) => {
    if (s.key) keys.push(i + 1);
  });

  const build = (chunkOffset) => {
    const stbl = box(
      'stbl',
      fullBox('stsd', 0, 0, u32(1), sampleEntry({ codec, width, height, description, vp9 })),
      fullBox('stts', 0, 0, u32(1), u32(n), u32(delta)),
      fullBox('stss', 0, 0, u32(keys.length), ...keys.map(u32)),
      fullBox('stsc', 0, 0, u32(1), u32(1), u32(n), u32(1)),
      fullBox('stsz', 0, 0, u32(0), u32(n), ...samples.map((s) => u32(s.data.length))),
      fullBox('stco', 0, 0, u32(1), u32(chunkOffset))
    );
    const minf = box(
      'minf',
      fullBox('vmhd', 0, 1, zeros(8)),
      box('dinf', fullBox('dref', 0, 0, u32(1), fullBox('url ', 0, 1))),
      stbl
    );
    const mdia = box(
      'mdia',
      fullBox('mdhd', 0, 0, u32(0), u32(0), u32(timescale), u32(durTs), u16(0x55c4), u16(0)),
      fullBox('hdlr', 0, 0, u32(0), str('vide'), zeros(12), str('VideoHandler'), u8(0)),
      minf
    );
    const trak = box(
      'trak',
      fullBox('tkhd', 0, 3, u32(0), u32(0), u32(1), u32(0), u32(durMs), zeros(8), u16(0), u16(0), u16(0), u16(0), MATRIX, u32(width << 16), u32(height << 16)),
      mdia
    );
    const mvhd = fullBox('mvhd', 0, 0, u32(0), u32(0), u32(1000), u32(durMs), u32(0x00010000), u16(0x0100), zeros(10), MATRIX, zeros(24), u32(2));
    return box('moov', mvhd, trak);
  };

  const ftyp = box('ftyp', str('isom'), u32(0x200), str('isom'), str('iso2'), str(codec === 'avc' ? 'avc1' : 'vp09'), str('mp41'));
  const dataLen = samples.reduce((a, s) => a + s.data.length, 0);
  // اندازه‌ی moov به offset بستگی ندارد (stco همیشه ۴ بایت) → یک بار برای اندازه، یک بار با offsetِ درست
  const moovSize = build(0).length;
  const moov = build(ftyp.length + moovSize + 8);
  const mdatHead = cat([u32(dataLen + 8), str('mdat')]);
  return new Blob([ftyp, moov, mdatHead, ...samples.map((s) => s.data)], { type: 'video/mp4' });
}
